const en = {
  'Language Key': 'en',
  'cui-org-info': 'Organization info',
  'cui-sign-on-info': 'Sign on info',
  'cui-user-info': 'User info',
  'cui-preferences': 'Preferences',
  'cui-review': 'Review',
  'cui-org': 'Organization',
  'cui-company-division': 'Company / Division',
  'cui-org-address': 'Organization Address',
  'cui-user-address': 'User Address',
  'cui-country': 'Country',
  'cui-city': 'City',
  'cui-state': 'State / Province',
  'cui-postal': 'Postal code',
  'cui-user-id': 'User ID',
  'cui-password': 'Password',
  'cui-password-re': 'Re-enter password',
  'cui-challenge-question': 'Challenge question',
  'cui-challenge-answer': 'Challenge answer',
  'cui-favorite-pet-q': "What's your favorite pet's name?",
  'cui-mother-q': "What's your mother's maiden name?",
  'cui-best-friend-q': "Who's your best friend?",
  'cui-first-name': 'First name',
  'cui-last-name': 'Last name',
  'cui-email': 'Email',
  'cui-email-re': 'Re-enter email',
  'cui-telephone': 'Telephone number',
  'cui-timezone': 'Timezone',
  'cui-submit': 'SUBMIT',
  'cui-next': 'NEXT STEP',
  'cui-previous': 'PREVIOUS',
  'cui-create-security-admin-account': 'Create your security administrator account',
  'cui-skip-for-now': 'SKIP FOR NOW',
  'icon-library': 'Icon Library',
  'cui-new-TLO': 'New Top Level Organization',
  'cui-new-TLO-description': 'Select this method if you wish to join the Covisint Exchange as a new Covisint Organization',
  'cui-new-division': 'New Division',
  'cui-new-division-description-start': 'Select this method if you would like to become the',
  'cui-new-division-description-end': 'of a new division within an existing Covisint Organization.',
  'cui-security-administrator': 'Security Administrator',
  'cui-new-user': 'New User',
  'cui-new-user-description': 'Select this method if you are an employee of an existing Covisint Member Company seeking access to an application your organization subscribes to or if you are not sure if your organization is registered.',
  'cui-sign-up': 'Sign Up',
  'cui-address': 'Address',
  'cui-organization-name': 'Company/Division',
  'cui-supplier-code': 'Supplier Code',
  'cui-address-1': 'Address 1',
  'cui-address-2': 'Address 2',
  'cui-user-information': 'User Information',
  'cui-organization-information': 'Organization Information',
  'cui-sign-in-information': 'Sign In Information',
  'cui-package-selection': 'Package Selection',
  'cui-welcome-popover': 'The responsibilities of the Security Administrator will be explained in detail after you select a registration method. However, you may choose to cancel your registration in order to allow a different member of your Organiziation to register as the Security Administrator.',
  'create-account': 'Create Your Account',
  'cui-agree-covisint': 'I agree to the Covisint',
  'terms-of-service': 'Terms of Service',
  'cui-and': 'and',
  'privacy-policy': 'Privacy Policy',
  'cui-tos-agree': 'You must agree to the Terms of Service to continue.',
  'cui-user-profile': 'User Profile',
  'cui-my-profile': 'My Profile',
  'cui-login': 'Login',
  'cui-supplier-content': 'Update this once the design docs come in. This is in the translation google doc. Lorem Ipsum. Other stuff. Supplier code important information. I like turtles.',
  'cui-all-organizations': 'All Organizations:',
  'cui-application-select-info': 'You can always make your selections after logging in for the first time.',
  'cui-all-applications': 'All applications',
  'cui-page-not-found': 'Page Not Found',
  'cui-page-not-found-content': 'The page you are looking for could have been deleted or never have existed.',
  'cui-home': 'HOME',
  'cui-access-denied': 'Access Denied',
  'cui-access-denied-content': 'You are not authorized to view this page.',
  'cui-registration-status': 'Registration Status',
  'cui-pending-status': 'Pending Status',
  'cui-pending-status-content': "Your registration status is still pending. You'll receive an email with more details shortly.",
  'cui-thank-you': 'Thank you',
  'cui-request-submitted': 'Request Submitted',
  'cui-success': 'Success',
  'cui-success-content': "Your Covisint registration has been successfully submitted. You'll receive an email with more details shortly.",
  'cui-check-your': 'Check your',
  'cui-registration-status-lower': 'registration status',
  'cui-application-selection': 'Application Selection',
  'cui-applications': 'Applications',
  'cui-profile-settings': 'Profile Settings',
  'cui-name': 'Name',
  'cui-update': 'Update',
  'cui-updated': 'Updated',
  'cui-error-try-again': 'Error! Try Again?',
  'cui-back': 'Back',
  'cui-selections': 'Selections',
  'cui-add-org': 'Add Organization',
  'cui-remove-org': 'Remove Organization',
  'cui-select-org': 'Select Organization',
  'cui-more-information': 'More Information',
  'cui-inv-user-popover-info': 'For security reasons, you must register with the e-mail your invite was sent. This can be edited within user settings when registration is complete.',
  'cui-org-profile': 'Organization Profile',
  'cui-info': 'Info',
  'cui-admins': 'Admins',
  'lowercase-not-allowed': 'not have any lower case letters',
  'uppercase-not-allowed': 'not have any upper case letters',
  'numbers-not-allowed': 'not have any numbers',
  'special-not-allowed': 'not have any special symbols (ex: ! * +)',
  'chars-not-allowed': 'not contain any of the following chars: {{disallowedChars}}',
  'words-not-allowed': 'not contain any of the following words: {{disallowedWords}}',
  'password-length': 'have between {{min}}-{{max}} characters',
  'password-rules': 'have {{requiredNumberOfCharClasses}} of the following:',
  'password-lowercase': 'at least 1 lower case letter',
  'password-uppercase': 'at least 1 upper case letter',
  'password-number': 'at least 1 number',
  'password-special': 'at least 1 special symbol (ex: ! * + )',
  'passwords-must': 'Passwords must:',
  'welcome-title': 'Register for one of the following',
  'cui-application-name': 'Application Name',
  'cui-application-tos': 'Review Terms & Conditions',
  'cui-application-tos-agreement': 'Terms & Conditions Agreement',
  'cui-package-tos': 'You have not accepted terms for the packages selected.',
  'cui-view-tos': 'View Terms & Conditions',
  'password-mismatch': 'Passwords must match',
  'cui-back-to-review': 'Back to Review',
  'email-mismatch': 'Emails must match',
  'no-applications-selected': "You don't have any applications selected. Click here to go back to application selection.",
  'cui-all-fields-required': 'All fields are required',
  'cui-complete-registration': 'Complete your registration below with',
  'cui-registered': 'Registered',
  'cui-open': 'Open',
  'cui-close': 'Close',
  'cui-street-address': 'Street Address',
  'cui-zip': 'Zip',
  'cui-language': 'Language',
  'cui-phone-main': 'Main',
  'cui-phone-office': 'Office',
  'cui-phone-fax': 'Phone/Fax',
  'cui-phone-mobile': 'Mobile',
  'cui-save': 'Save',
  'cui-cancel': 'Cancel',
  'cui-edit': 'Edit',
  'cui-phone': 'Phone',
  'search-by-app-name': 'Search by application name',
  'new-request': 'New Request',
  'select-applications': 'Select Applications',
  'browse-applications': 'Browse Applications',
  'go': 'Go',
  'filter-list': 'Filter List',
  'filter': 'Filter',
  'owning-org': 'Owning Org',
  'my-applications': 'My Applications',
  'app-summary': 'App Summary',
  'granted': 'Granted',
  'bundled-applications': 'Bundled Applications',
  'application-details': 'Application Details',
  'my-claims': 'My Claims',
  'related-applications': 'Related Applications',
  'review-request': 'Review Request',
  'back-to-search': 'Back to Search',
  'requested-items': 'Requested Items',
  'request-reason': 'Request Reason',
  'reason-im-requesting': "Reason I'm requesting",
  'you-must-enter-a-reason': 'You must enter a reason to request this app',
  'cui-org-no-applications': "Seems like your organization doesn't have any applications. You can always try again after logging in.",
  'cui-filter-org-name': 'Filter by organization name',
  'cui-address-example': 'Apt, Suite, Bldg. (optional)',
  'cui-filter-app-name': 'Filter by application name',
  'cui-search-user-name': 'Search users by name',
  'page': 'Page',
  'cui-num-results-page': 'Results per page',
  'submit-request': 'Submit Request',
  'categories': 'Categories',
  'cui-answer': 'Answer',
  'cui-enter-password': 'Enter Password',
  'cui-enter-new-password': 'Enter new password',
  'cui-re-enter-new-password': 'Re-enter new password',
  'granted-to-my-org': 'Granted to my organization',
  'collected-items-for-request': 'Collected Items for Request',
  'cui-invalid-password': 'Invalid password. Please try again.',
  'cui-faq': 'FAQ',
  'cui-frequently-asked-questions': 'Frequently Asked Questions',
  'cui-admin-tools': 'Admin Tools',
  'cui-this-field-is-required': 'This field is required.',
  'cui-this-field-needs-to-be-longer': 'This field needs to be longer.',
  'cui-you-need-to-agree-to-toc': 'You need to agree to the Terms of Service before you continue.',
  'cui-this-is-not-valid-email': 'This is not a valid email.',
  'cui-my-app-requests': 'My Application Requests',
  'cui-no-claims': 'You have no claims for this application.',
  'cui-no-details': 'No details available.',
  'request': 'Request',
  'all': 'All',
  'no-selected-apps': "You haven't selected any applications.",
  'basic-info': 'Basic Information',
  'cui-error-username-exists': 'User ID already exists! Please choose another one.',
  'password-reset': 'Password Reset',
  'current-password': 'Current Password',
  'timezone-and-language': 'Timezone and Language',
  'challenge-questions': 'Challenge Questions',
  'security-question-repeated': 'This answer has already been used.',
  'cui-by-date-added': 'Date Added',
  'cui-alphabetically': 'Alphabetical',
  'active': 'Active',
  'pending': 'Pending',
  'suspended': 'Suspended',
  'title': 'Title',
  'id': 'ID',
  'url': 'Url',
  'privacy-terms': 'Privacy & Terms',
  'help': 'Help',
  'cui-learn-more-start': 'Learn more',
  'cui-learn-more-end': 'about why we ask for this information',
  'cui-org-hierarchy': 'Organization Hierarchy',
  'directory': 'Directory',
  'userID': 'User ID',
  'status': 'Status',
  'locked': 'Locked',
  'rejected': 'Rejected',
  'removed': 'Removed',
  'sort': 'Sort',
  'refine': 'Refine',
  'or': 'Or',
  'organizations': 'Organizations',
  'roles': 'Roles',
  'organization-applications': 'Organization Applications',
  'unactivated': 'Unactivated',
  'log-out': 'Log Out',
  'welcome': 'Welcome',
  'privacy': 'Privacy',
  'terms': 'Terms',
  'user': 'User',
  'top-level-orgs': 'Top Level Organizations',
  'invite-user': 'Invite User',
  'invite-division': 'Invite Division',
  'username': 'Username',
  'move': 'move',
  'no-bundled-or-related': 'No bundled or related apps.',
  'cui-continue': 'Continue',
  'cui-no-org-divisions': 'No organization divisions',
  'inactive': 'Inactive',
  'deny': 'Deny',
  'approve': 'Approve',
  'pending-request': 'Pending Request',
  'review-approvals': 'Review Approvals',
  'cui-package-no-claims': 'This package contains no claims',
  'claims': 'Claims',
  'package-name': 'Package Name',
  'submit-approvals': 'Submit Approvals',
  'view-details': 'View Details',
  'request-date': 'Request Date',
  'registration-decision': 'Registration Decision',
  'requested': 'Requested',
  'getting-user-info': 'Getting your user information...',
  'approvals-submitted': 'Approvals Submitted',
  'rejection-submitted': 'Rejection Submitted',
  'approval-summary': 'Approval Summary',
  'approved-items': 'Approved Items',
  'rejected-items': 'Rejected Items',
  'registration-request-approved': 'Approved registration request',
  'registration-request-rejected': 'Rejected registration request',
  'no-items-rejected': 'No items rejected',
  'no-items-approved': 'No items approved',
  'registration-request': 'Registration Request',
  'custom-api-loading': 'Initializing the app...',
  'new-grant': 'Grant App',
  'search-by-package-name': 'Search by package name',
  'search': 'Search',
  'administartor-?': 'Administrator?',
  'submit-grant-update': 'Submit grant update',
  'review-user-pending-approval': 'Review User Pending Approval',
  'view-request-for': 'View Request for',
  'job-title': 'Job Title',
  'query': 'Query',
  'suspend-app': 'Suspend App',
  'new-grants': 'New Grants',
  'update-grant-settings': 'Update Grant Settings',
  'assign-new-grant-to': 'Assign new grant to',
  'division': 'Division',
  'redirecting-to-sso': 'Requesting your credentials',
  'included-applications': 'Included Applications',
  'selected-sub-packages': 'Selected Sub-Packages',
  'specify-password': 'Specify password',
  'suspend': 'Suspend',
  'reset-password': 'Reset Password',
  'confirm-password-reset': 'Are you sure you want to reset the password for this user?',
  'yes': 'Yes',
  'within': 'within',
  'search-within': 'Search within',
  'in-your-org': 'in your org',
  'people': 'People',
  'revoke-package': 'Revoke Package',
  'cui-by-username': 'Username',
  'cui-by-status': 'Status',
  'cool-got-it': 'Cool, got it',
  'organization-directory': 'Organization Directory',
  'org-nav-invite-links': 'Organization Navigation and Invitation Links',
  'org-dir-filters': 'Organization Directory Filters',
  'org-dir-list': 'Organization Directory List',
  'apps': 'Apps',
  'apps-upper': 'APPS',
  'history-upper': 'HISTORY',
  'profile-upper': 'PROFILE',
  'roles-upper': 'ROLES',
  'your-app-request-in-review': 'Your application request has been submitted',
  'error-generic': 'There was an issue loading data on this page. Please try again.',
  'cui-application-administrator': 'doesn’t currently have the role of application administrator, which must be assigned before a user can be granted administration rights for a given application. This is one time setting.',
  'cui-assign-confirm': 'Would you like to assign this role now?',
  'cui-suspend-warning': 'will be unable to access this application',
  'cui-suspend-confirm': "Are you sure you'd like to suspend now?",
  'cui-notify-user': 'Notify User',
  'cui-users': 'Users',
  'cui-no': 'No',
  'cui-remove': 'Removed',
  'cui-org-abbrev': 'Org',
  'cui-userProfile-user-error': 'There was an error retrieving user data. Please try again.',
  'cui-userProfile-security-error': 'There was an error retrieving security question data. Please try again.',
  'cui-userProfile-password-error': 'There was an error retrieving password policy data. Please try again.',
  'cui-suspend-success': 'This application is now suspended from the selected user',
  'cui-unlock': 'Unlock',
  'cui-unlock-password-confirm': "Are you sure that you would like to unlock this user's password?",
  'cui-error-unlocking-password': "Sorry, there was an error unlocking this user's password.",
  'cui-error-person-request': 'Unable to retrieve registration request data for this user.',
  'cui-error-email-exists': 'Email address has already been taken',
  'cui-password-history-rule': 'not match any of your previous {{numberOfPasswords}} passwords',
  'cui-password-policy': 'Password Policy',
  'cui-security-admin': 'Security Administrators',
  'cui-button-loading-text': 'Loading...',
  'cui-username-taken': 'Username is taken',
  'cui-no-applications': 'You currently have no applications',
  'cui-mask-answers': 'Mask/Unmask security answers',
  'cui-pwd-reset-success': 'Password Reset Success!',
  'cui-last-login': 'Last Login',
  'cui-need-different-app': 'Need a different application',
  'cui-go-back-to': 'Go back to',
  'cui-tos-applications': 'Please accept Terms & Conditions for the selected applications',
  'cui-selected-apps': 'Selected Applications',
  'cui-authentication-policy': 'Authentication Policy',
  'cui-selected': 'Selected',
  'cui-tac': 'Terms and Conditions',
  'cui-accept': 'Accept',
  'cui-tac-agree': 'You must agree to the Terms and Conditions to continue.',
  'cui-printer-friendly-tac': 'Printer-friendly Terms & Conditions',
  'cui-my-history': 'My History',
  'cui-status-history': 'My Status History',
  'cui-app-history': 'Application History',
  'cui-password-change-log': 'Password change log',
  'cui-date': 'Date',
  'cui-event-type': 'Event Type',
  'cui-action-by': 'Action Performed by',
  'cui-notes': 'Notes',
  'cui-try-again': 'Please try again.',
  'cui-password-change-log-error': 'There was an error retrieving Password change log.',
  'cui-userstatus-history-error': 'There was an error retrieving User status history.',
  'cui-claims-error': 'There was an error retrieving Claims.',
  'cui-org-app-suspend-success': 'This application is now suspended from the selected organizations, all users, and all sub organizations.',
  'cui-org-app-suspend-msg1': 'This action will suspend the action from all users and sub organizations even when in active use.',
  'cui-org-app-suspend-msg2': 'Are you sure you wish to suspend',
  'cui-from': 'from',
  'cui-application-granted-history': 'Application Grant History',
  'cui-application-requested-history': 'Application Request History',
  'approved': 'Approved',
  'decision': 'Decision',
  'evaluator': 'Evaluator',
  'action': 'Action',
  'cui-invalid-invitation': 'Invitation is either already used or Invalid',
  'cui-by-request-date': 'Request Date',
  'cui-by-decision-date': 'Decision Date',
  'cui-no-orgs-for-name': 'No organizations found for the specified name. Please try with a different name.',
  'requests': 'Requests',
  'no-pending-apps': 'You have no pending application requests.',
  'description': 'Description',
  'launch': 'Launch',
  'manage-applications': 'Manage Applications',
  'request-type': 'Request Type',
  'phase': 'Phase',
  'date-submitted': 'Date Submitted',
  'cui-pending-requests-error': 'There was an error in retrieving/updating requests.',
  'no-requests-by-name': 'No requests found for the specified name. Please try with a different name.',
  'cannot-change-password': 'Cannot change password now',
  'select-claims': 'Select Claims',
  'grant-reason': 'Grant Reason',
  'grants-assigned': 'New Grants Assigned',
  'suspend-error': 'There was an error in suspend requests.',
  'unsuspend-error': 'There was an error in unsuspend requests.',
  'approval': 'Approval',
  'administrator': 'Administrator',
  'submitted': 'Submitted',
  'no-bundled': 'No bundled apps',
  'disallowed-password-rule': 'Cannot contain a word on the disallowed words list',
  'request-approve-or-rejected': 'This request is either Approved/Rejected',
  'application': 'Application',
  'show-all': 'Show All',
  'cui-subject': 'Subject',
  'cui-es': '(es)',
  'cui-invite-user': 'Invite a User within',
  'cui-invite-user-success': 'your user invitation request sent',
  'cui-email-recipt': 'Enter recipient email (separate multiple with commas)',
  'cui-invite-verbiage': 'Invite for one of the following',
  'select': 'Select',
  'change-org': 'Change Org',
  'cui-invite-user-sub': 'Register as a user to join',
  'cui-invite-user-select': 'Search for an org',
  'cui-send-invitation': 'Send Invitation',
  'invite': 'Invite',
  'cui-invite-tlo-success': 'Your top level organization invitation request sent',
  'cui-invite-tlo': 'Invite a New Organization',
  'cui-invite-division-success': 'Your company invitation request sent',
  'cui-invite-division': 'Invite an Organization',
  'cui-tlo-sub': 'Register as a new organization',
  'cui-division-sub': 'Register as an adminstrator within',
  'search-by-org-name': 'Search by organization name',
  'app-approval-error': 'There was an error in approving App requests.',
  'modify-claims': 'Modify Claims',
  'unsuspend-app': 'Unsuspend App',
  'remove-app': 'Remove App',
  'user-details': 'User Details',
  'reason': 'Reason',
  'required': 'Required',
  'cui-unsuspend-confirm': "Are you sure you'd like to unsuspend now?",
  'unsuspend': 'Unsuspend',
  'remove-confirm': "Are you sure you'd like to remove now?",
  'remove': 'Remove',
  'my-organization': 'My Organization',
  'request-app': 'Request App',
  'no-apps-found': 'No applications found.',
  'refine-search': 'Please refine your search criteria.',
  'your-assign-role-success': 'New Role Assigned',
  'cui-assigned-roles': 'Assigned Roles',
  'cui-available-roles': 'Available Roles',
  'cui-browse-by-category': 'Browse by category',
  'cui-back-navigation-requests': 'Back navigation and Requests',
  'cui-search-results': 'Search Results',
  'cui-new-grant-search-results': 'New Grant Search Results',
  'cui-username-close': 'User name and close navigation',
  'cui-user-no-apps': 'User has no applications',
  'cui-no-roles-assigned': 'This user has no assigned roles.',
  'status-history': 'Status History',
  'cui-no-status-history': 'This user has no status history.',
  'cui-pwd-reset-msg1': 'Password Reset is successful. New password is:',
  'cui-pwd-reset-msg2': 'Note: if you are seeing only first half password then the second half password will be sent to users registered email.',
  'users-upper': 'USERS',
  'hierarchy-upper': 'HIERARCHY',
  'privileges': 'Privileges',
  'expand-all': 'Expand All',
  'collapse-all': 'Collapse All',
  'no-records': 'No records found.',
  'contact-us': 'Contact Us',
  'cui-error-organization-request': 'Unable to retrieve registration request data for this organization.',
  'cui-error-organization-app-request': 'Unable to retrieve app request data for this organization',
  'cui-error-user-app-request': 'Unable to retrieve app request data for this user',
  'assign': 'Assign',
  'search-by-person-name': 'Search by person name',
  'grant-history': 'Grant History',
  'request-history': 'Request History',
  'social-login': 'Social Login',
  'facebook': 'Facebook',
  'twitter': 'Twitter',
  'link': 'Link',
  'unlink': 'Unlink',
  'invalid-url': 'This is not a valid URL.',
  'linkedin': 'LinkedIn',
  'google': 'Google',
  'administration': 'Administration',
  'services': 'Services',
  'n-phase': 'N - Phase Approval',
  'edit-package': 'Edit Package',
  'is-requestable': 'Is Requestable',
  'is-displayable': 'Is Displayable',
  'is-grantable': 'Is Grantable',
  'require': 'Require',
  'is-requestable-desc': 'Indicate if user can request this application.',
  'is-grantable-desc': 'Indicate if this application can be granted directly by company administration to the user',
  'is-displayable-desc': 'Indicate if the package icon should be displayed on My Applications page',
  'require-reason-desc': 'Indicate if this package required the user to supply a reason for requesting this package',
  'company-admin': 'Company Admin',
  'application-admin': 'Application Admin',
  'company-admin-desc': 'This is the default approval phase, it should be Yes if there is no other phase required',
  'application-admin-desc': 'Does the user application request needs to be approved by the application administrator?',
  'add-admins': 'Add Administrators',
  'cardinality-indicator': 'Cardinality Indicator',
  'cui-one': 'One',
  'cui-many': 'Many',
  'claim-values': 'Claim Values',
  'cui-add': 'Add',
  'cui-view': 'View',
  'cui-claim': 'Claim',
  'cui-category': 'Category',
  'cui-service': 'Service',
  'cui-delete': 'Delete',
  'federation-conn': 'Federation Connection',
  'updated-date': 'Updated Date',
  'target-url': 'Target URL',
  'remote-app-id': 'Remote Application Id',
  'mobile-sso-url': 'Mobile SSO URL',
  'mobile-app-id': 'Mobile App ID',
  'cui-package': 'Package',
  'cui-create': 'Create',
  'more-languages': 'More Languages',
  'duplicate-language-error': 'Duplicate languages are not allowed',
  'cui-nextstep': 'Next',
  'create-package': 'Create Package',
  'manage-package-claims': 'Manage Package Claims',
  'cardinality-indicator-error': 'Cardinality Indicator cannot be one',
  'value-id-exists': 'Value Id already exists',
  'claim-id-exists': 'Claim Id already exists',
  'cui-new': 'New',
  'package-success-content': 'Package created successfully',
  'add-claims': 'Add Claims',
  'package-update-success': 'Package updated successfully'
}

export {
  en
}



// WEBPACK FOOTER //
// ./src/plugins/i18n/en.js